import instObj from '@/backend/axios-instances'

const resource = "/products/type"
const instance = instObj.baseInstance

export default {
  get(productTypeId, parameters) {
    return instance.get(`${resource}/${productTypeId}`, { params: parameters });
  },
  put(productTypeId, data, parameters) {
    return instance.put(`${resource}/${productTypeId}`, data, { params: parameters });
  },
  delete(productTypeId) {
    return instance.delete(`${resource}/${productTypeId}`);
  }
}
